import React from "react";
import "../App.css";

function Header(props) {
  return (
    <header className="Header">
      <div className="Header-text">
        {props.children}
        <div className="Header-shadow" />
      </div>
      <div className="Header-line"></div>
    </header>
  );
}

export default Header;
